"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionFactory = void 0;
var common_session_1 = require("./common-session");
// import { WpsSession } from './wps-session';
var SessionFactory = /** @class */ (function () {
    function SessionFactory() {
    }
    SessionFactory.createSession = function () {
        // wps插件2.0内，待完善插件wps session的方法
        // if (window.Extention) {
        //   return new WpsSession();
        // }
        return new common_session_1.CommonSession();
    };
    return SessionFactory;
}());
exports.SessionFactory = SessionFactory;
exports.default = SessionFactory.createSession();
